<template>
    <div class="container">
        <div v-if="!startStatus" class="count-down-box">
            <transition name="van-slide-down">
                <div v-show="showCountDown"><span class="num">{{countDownNum}}</span></div>
            </transition>
        </div>
        <div v-if="startStatus">
            <ul class="red_packet" id="red_packet">
                <template v-for="(item, index) in liParams">
                    <li class="package"  :key="index"
                            :style="{
                                    left: item.left,
                                    width:item.width,
                                    height:item.width,
                                    animationDuration: item.durTime,
                                    webkitAnimationDuration: item.durTime
                                  }"
                            :data-index="index"
                            @webkitAnimationEnd="removeDom"
                            @click="tap(item)"
                    >
                        <a href="javascript:">
                            <i
                                    :style="{transform: item.transforms, webkitTransform: item.transforms}"
                                    :class="[{ 'default':item.status==0},{'success':item.status==1},{'fail':item.status==2}]"
                            ></i>
                        </a>
                    </li>
                </template>
            </ul>
        </div>

        <Modal ref="modal" @hide="modalHide">
            <div class="content">
                <div class="tip-top">本场草莓雨已下完</div>
                <div class="tip-top-sub">您还剩{{remainCount}}张草莓雨入场券</div>
                <div class="btn" style="margin: 80px auto 0;" @click="play_again">再玩一次</div>
                <div class="btn" style="margin: 20px auto 0;" @click="share">邀请朋友一起玩</div>
            </div>
        </Modal>

    </div>
</template>

<script>
    import Modal from "../../../components/Common/Modal";
    import { mapActions } from 'vuex';

    export default {
        name: "RainGame",
        components: {Modal},
        data(){
            return {
                client_id:this.$route.params.uid,
                game_id:this.$route.params.gid,
                remainCount:this.$route.params.ticket_qty,
                startStatus: false,   //草莓雨启动状态
                liParams: [], // 红包数组
                timer: null,   // 红包雨定时器
                showCountDown:false,
                countDownNum:3,
                timerCountDown: null,
            }
        },
        watch:{
            startStatus(val){
                if(!val){
                    this.$refs.modal.handleShow();
                    clearTimeout(this.timer);
                }
            }
        },
        methods:{
            ...mapActions([
                'OpenPackage',
            ]),
            play_again(){
                //再玩一次
                console.log('再玩一次');
                if(this.remainCount<=0){
                    //没有券了，不能玩，提示分享
                    this.$Dialog.alert({
                        message: '您的草莓雨入场券已用完，去邀请朋友一起玩以获得更多入场券！',
                        theme: 'round-button',
                    });
                }else{
                    this.$router.go(-1);
                }
            },
            share(){
                //分享
                console.log('分享');
            },
            readyGo(){
                // this.showCountDown=true;
                this.timerCountDown = setInterval(()=>{
                    if(this.countDownNum>0){
                        this.showCountDown=!this.showCountDown;
                    }else {
                        this.showCountDown=false;
                    }
                    setTimeout(()=>{
                        if(this.countDownNum===0){
                            clearInterval(this.timerCountDown);
                            this.showCountDown=false;
                            this.startStatus=true;
                            this.startRedPacket();
                        }else{
                            if(!this.showCountDown){
                                this.countDownNum--;
                            }
                        }
                    },400);

                },1000);
            },
            modalHide(){
                //关闭结束弹框后回到首页
                this.$router.go(-1);
            },
            tap(item){
                item.status = 1;
                let p={'uid':this.client_id,'gid':this.game_id};
                this.OpenPackage(p).then(res=>{
                    console.log(res);
                    if(res.status>0){
                        //未中奖
                        this.$toast({
                            message: '未中奖，继续加油！',
                            duration: 500,
                            position: 'top'
                        });
                    }else{
                        //中奖了
                        this.$toast({
                            message: '恭喜，获得'+res.responseObject+'！',
                            duration: 500,
                            position: 'top'
                        });
                    }
                })
            },
            removeDom(e) {
                let target = e.currentTarget;
                document.querySelector('#red_packet').removeChild(target);
                if (!document.querySelector('.package')) {
                    // 草莓雨结束
                    this.gameEnd();
                }
            },
            gameEnd() {
                this.startStatus = false;
                this.liParams = [];
            },
            startRedPacket() {
                let win = document.documentElement.clientWidth || document.body.clientWidth
                let rotate = (parseInt(Math.random() * 90 - 45)) + "deg" // 旋转角度
                // let w = (Math.random() * 90) + 60
                // let scale = Math.random()*(1.0-0.6)+0.6;
                let scale = 0.6;
                let durTime = parseInt(Math.random() * 1.5) + 3.0 + 's' // 时间
                let left = parseInt(Math.random() * win)
                if (left < 0) {
                    left = 0
                } else if (left > win - 130) {
                    left = (win - 130)
                }

                this.liParams.push({
                    left: left + 'px',
                    // width: w + 'px',
                    transforms: `rotate(${rotate}) scale(${scale})`,
                    durTime: durTime,
                    status: 0  // 0 默认 1 中奖 2 未中奖
                })
                // 红包密度
                this.timer = setTimeout(() => {
                    this.startRedPacket()
                }, 500)
            },
        },
        mounted() {
            console.log('mounted!');
            setTimeout(()=>{
                console.log('15秒时间到！结束了');
                this.startStatus=false;
            },25000);
        },
        created() {
            if(!this.client_id){
                this.$router.go(-1);
                return;
            }
            console.log('created！');
            this.readyGo();
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        width: 100%;
        height: 100%;
        background: url(../../../assets/rain/rain-bg.png) no-repeat center;
        background-size: 100% 100%;
        position: absolute;
        overflow: hidden;

        .content {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 300px;
            height: 352px;
            background: url("../../../assets/rain/bg-box.png") no-repeat center;
            background-size: 100% 100%;
            text-align: center;

            .tip-top {
                font-size: 18px;
                color: #eb393a;
                margin-top: 30px;
            }
            .tip-top-sub {
                font-size: 14px;
                color: #eb393a;
                margin-top: 80px;
            }

            .amount {
                margin-top: 100px;
                font-size: 100px;
                color: #eb393a;
            }
            .btn {
                width: 200px;
                height: 44px;
                line-height: 44px;
                font-size: 16px;
                color: #ffffff;
                background: url("../../../assets/rain/bg-btn.png") no-repeat center;
                background-size: 100% 100%;
            }

            .tip-bottom {
                margin-top: 40px;
                font-size: 26px;
                line-height: 54px;
                color: #808080;
            }
        }

        .count-down-box{
            top: 500px;
        }
        .num{
            font-size: 72px;
            font-weight: bolder;
            color: #E34928;
        }

        .total {
            z-index:1;
            position: absolute;
            left: 50%;
            bottom: 20px;
            padding: 20px 28px;
            background-color: rgba(0,0,0,.7);
            border-radius: 20px;
            color: #ffffff;
            font-size: 32px;
            transform: translateX(-50%);
        }
        .clock-container {
            display: flex;
            align-items: center;
            position: absolute;
            bottom: 50%;
            left: 50%;
            transform: translateX(-50%);
        }

        .colon {
            height: 50px;
            padding: 0 10px;
            display: flex;
            justify-content: space-around;
            flex-direction: column;

            &::after,
            &::before {
                content: '';
                display: block;
                width: 10px;
                height: 10px;
                background: #ffffff;
                border-radius: 50%;
            }
        }

        .btn-wrapper {
            width: 100%;
            position: absolute;
            bottom: calc(50% + 240px);
            text-align: center;
            color: #ffffff;
            text-align: center;

            .btn {
                margin: 0 auto;
                width: 460px;
                height: 102px;
                line-height: 102px;
                font-size: 38px;
                background: url("../../../assets/rain/bg-btn.png") no-repeat center;
                background-size: 100% 100%;
            }
        }

        .tip-top {
            width: 100%;
            text-align: center;
            color: #ffffff;
            font-size: 40px;
            position: absolute;
            bottom: calc(50% + 120px);
        }

        .tip-middle {
            width: 100%;
            text-align: center;
            color: #ffffff;
            font-size: 40px;
            position: absolute;
            bottom: calc(50% - 10px);
        }

        .bag {
            width: 100%;
            text-align: center;
            color: #ffffff;
            font-size: 40px;
            position: absolute;
            bottom: 50px;

            img {
                width: 450px;
            }
        }

        .nomore {
            width: 500px;
        }

        //.nomore {
        //  width: 100%;
        //  text-align: center;
        //  color: #ffffff;
        //  font-size: 40px;
        //  position: absolute;
        //  bottom: 50%;
        //  transform: translateY(50%);
        //  img {
        //    width: 480px;
        //  }
        //}
        .redNum {
            .icon {
                display: inline-block;
                width: 41px;
                height: 41px;
                background: #6C0A75;
                font-size: 15px;
                line-height: 46px;
                text-align: center;
                position: absolute;
                top: 20px;
                right: 20px;
                z-index: 4;
                background: url('../../../assets/rain/clock.png') no-repeat center;
                background-size: 100% 100%;

                i {
                    font-size: 12px;
                }
            }
        }

        .red_packet {
            i {
                width: 80px;
                height: 85px;
                display: block;

                &.default {
                    background: url('../../../assets/rain/cm.png') no-repeat center;
                    background-size: 100% 100%;
                }

                //&.fail{
                //  background: url('../assets/images/red_fail.png') no-repeat center;
                //  background-size: 100% 100%;
                //}

                &.success {
                    width: 80px;
                    height: 85px;
                    background: url('../../../assets/rain/cm_success.png') no-repeat center;
                    background-size: cover;
                }
            }

            li {
                position: absolute;
                animation: all 3s linear;
                top: -100px;
                z-index: 3;

                &.package {
                    animation: aim_move 5s linear 1 forwards;
                }
            }

            a {
                display: block;
            }
        }

        @keyframes aim_move {
            0% {
                transform: translateY(0);
            }
            100% {
                transform: translateY(120vh);
            }
        }
    }
</style>
